import type { AmlStatusEnum } from "../model/index";

export const AmlStatus = {
  UNC: "UNC",
  ACT: "ACT",
  REF: "REF",
  EVI: "EVI",
  AUT: "AUT",
  REJ: "REJ",
  NRQ: "NRQ",
  SUB: "SUB"
} as const;

export const StatusNaming: { [k in AmlStatusEnum]: string } = {
  UNC: "Not Verified", // regarded as To Review
  ACT: "Verified",
  REF: "Referred",
  EVI: "Waiting for Documents",
  AUT: "Waiting for Authorisation", // regarded as To Review
  REJ: "Failed",
  NRQ: "Concession",
  SUB: "Submitted"
};

export const StatusColor: { [k in AmlStatusEnum]: string } = {
  REF: "#febf4b",
  ACT: "#72a160",
  EVI: "#9f75c0",
  UNC: "#15b0f0",
  AUT: "#5ac7f3",
  REJ: "#fe4b4b",
  NRQ: "#bbcce3",
  SUB: "#d9b0b0"
};

export const OnboardingModel = {
  RELIANCE: "R",
  NONE_RELIANCE: "N"
} as const;

export const OnboardingModelName: {[k in (typeof OnboardingModel)[keyof typeof OnboardingModel]]: string} = {
  R: "Reliance",
  N: "Non-Reliance"
};

export const ConcessionStatus = {
  Y: "Complete",
  N: "Missing",
} as const;
